// Baseroutes
export const STEP_ONE = "/co2-kosten-rechner";
export const STEP_TWO = "/co2-kosten-rechner/step2";
export const STEP_THREE = "/co2-kosten-rechner/step3";
export const STEP_FOUR = "/co2-kosten-rechner/step4";
export const STEP_FIVE = "/co2-kosten-rechner/step5";
export const STEP_SIX = "/co2-kosten-rechner/step6";
export const STEP_SEVEN = "/co2-kosten-rechner/step7";
export const STEP_EIGHT = "/co2-kosten-rechner/step8";
export const STEP_NINE = "/co2-kosten-rechner/step9";
export const RESULTS_PAGE = "/co2-kosten-rechner/step10";
export const SIMULATION_PAGE = "/co2-kosten-rechner/step11";

export const STEPS_PAGINATION = [
  STEP_ONE,
  STEP_TWO,
  STEP_THREE,
  STEP_FOUR,
  STEP_FIVE,
  STEP_SIX,
  STEP_SEVEN,
  STEP_EIGHT,
  STEP_NINE,
  RESULTS_PAGE,
];
